import { render, staticRenderFns } from "./SheetBlockAssociatedDocuments.vue?vue&type=template&id=316efe5c&scoped=true"
import script from "./SheetBlockAssociatedDocuments.vue?vue&type=script&lang=js"
export * from "./SheetBlockAssociatedDocuments.vue?vue&type=script&lang=js"
import style0 from "./SheetBlockAssociatedDocuments.vue?vue&type=style&index=0&id=316efe5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316efe5c",
  null
  
)

export default component.exports